var _path, _circle, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWagonDefault = function SvgWagonDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.8,
    d: "M14.74 14.194a.828.828 0 1 1-1.656 0 .828.828 0 0 1 1.656 0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.39,
    cy: 14.194,
    r: 0.828,
    stroke: "#1E242F",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M29.99 6.409c-1.843-1.039-3.859-1.455-5.396-1.584-.503-.043-.878.428-.758.919l.315 1.296a.76.76 0 0 0 .721.585c1.409.032 3.273.015 4.734-.002.717-.008 1.009-.862.384-1.214ZM16.055 5.303l.446 1.26a.777.777 0 0 1-.738 1.035c-2.11-.013-4.026.003-5.492.008-.427.002-.78-.346-.728-.77a4.9 4.9 0 0 1 .471-1.626c1.04-.386 3.887-.414 5.298-.427a.78.78 0 0 1 .743.52ZM22.47 5.242l.45 1.346a.774.774 0 0 1-.733 1.02H18.58a.78.78 0 0 1-.709-.463c-.242-.55-.476-1.095-.636-1.652a.64.64 0 0 1 .569-.818c1.222-.113 2.907-.048 4.021.051a.75.75 0 0 1 .643.516Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeLinecap: "round",
    strokeWidth: 0.774,
    d: "m11.37 14.11-4.831-.407a.774.774 0 0 1-.708-.816l.055-.947a.77.77 0 0 1 .142-.403l.426-.6a.8.8 0 0 0 .139-.365l.258-2.376a1 1 0 0 1 .018-.103c.084-.326.57-2.181 1.168-3.512a.57.57 0 0 1 .415-.342c2.192-.4 14.292-1.105 18.917-.296 3.236.945 5.148 2.5 7.191 3.574q.088.045.183.068c2.276.53 3.24.915 6.641 2.1a.46.46 0 0 1 .265.208c.271.507.88 2.176-.056 3.948a.71.71 0 0 1-.577.363l-3.218.263M16.37 14.42h16.58"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M16.121 14.195a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0ZM37.6 14.195a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0Z"
  })));
};
export default SvgWagonDefault;